import { useMediaQuery } from '@ori-ui/mui';
export var useIsDesktop = function useIsDesktop() {
  return useMediaQuery(function (theme) {
    return theme.breakpoints.up('md');
  });
};